import React, { useState, useRef } from 'react';
import { Card, Grid, Button, Box, Modal, Typography, TextField } from '@mui/material';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import history from 'history.js';
import useAuth from 'app/hooks/useAuth';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import BotaoArredondado from 'app/components/BotaoArredondado';

const useStyles = makeStyles(({ palette, ...theme }) => ({
    cardHolder: {
        background: '#1A2038',
    },
    card: {
        width: 500,
        borderRadius: 12,
        height: 'auto',
        padding: '2rem',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '1.5rem',
        width: '100%',
        height: '100%',
    },
    input: {
        width: '100%',
    },
    divBotao: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    mod: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        border: '2px solid #000',
        borderRadius: '25px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        backgroundColor: 'white',
        padding: '1rem',
        textAlign: 'center',
        justifyContent: 'center',
        gap: '1rem',
    },
    bMod: {
        width: '100vw',
        height: '100vh',
        zIndex: -1,
        backgroundColor: 'rgba(100, 100, 100, 0.5)',
    },
}));

const ForgotPassword = () => {
    const classes = useStyles();
    const { forgotpassword } = useAuth();
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email('E-mail inválido')
            .required('Esse campo é obrigatório'),
    });

    const handleFormSubmit = async (values, { setSubmitting }) => {
        try {
            await forgotpassword(values.email);
            handleOpen();
            setTimeout(() => {
                handleClose();
                history.push('/session/signin');
            }, 5000);
        } catch (e) {
            setMessage(e.message);
        } finally {
            setSubmitting(false);
        }
    };

    const closeButton = () => {
        handleClose();
        history.push('/session/signin');
    };

    return (
        <div>
            <div
                className={clsx(
                    'flex justify-center items-center  min-h-full-screen',
                    classes.cardHolder
                )}
            >
                <Card className={classes.card}>
                    <Formik
                        initialValues={{ email: '' }}
                        validationSchema={validationSchema}
                        onSubmit={handleFormSubmit}
                    >
                        {({ isSubmitting }) => (
                            <Form className={classes.form}>
                                <Field
                                    className={classes.input}
                                    as={TextField}
                                    variant="outlined"
                                    label="E-mail"
                                    name="email"
                                    type="email"
                                    fullWidth
                                />
                                <ErrorMessage
                                    name="email"
                                    component="div"
                                    className="text-error"
                                />
                                <div className={classes.divBotao}>
                                    <BotaoArredondado value="Enviar" disabled={isSubmitting} />
                                </div>
                                {message && (
                                    <p className="text-error">{message}</p>
                                )}
                            </Form>
                        )}
                    </Formik>
                </Card>
            </div>
            <div>
                <Modal
                    className={classes.bMod}
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className={classes.mod}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Recuperação de Senha
                        </Typography>
                        <Typography id="modal-modal-description">
                            Um link foi enviado para o seu e-mail de cadastro.
                        </Typography>
                        <Typography id="modal-modal-description">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={closeButton}
                            >
                                ENTENDI
                            </Button>
                        </Typography>
                    </Box>
                </Modal>
            </div>
        </div>
    );
};

export default ForgotPassword;
